import React, { useMemo } from "react";
import { useCommonWidths } from "../../../hooks";
import { Grid, makeStyles, Theme } from "@material-ui/core";
import { MyPageButton } from "../../common";
import { FormattedMessage } from "react-intl";
import { navigate } from "@reach/router";

type NavigationButtonsProps = {
	readonly nextDisabled: boolean;
	readonly prevBtnHidden: boolean;
	readonly handleNavigatePrev?: () => void | undefined;
	readonly handleNavigateNext: () => void;
	readonly isLastStep: boolean;
};

const useStyles = makeStyles((theme: Theme) => ({
	navigationButton: {
		borderRadius: 10,
		padding: "8px 22px",
		fontSize: 14,
		margin: "32px 0px",
		height: 56,
		[theme.breakpoints.down("sm")]: {
			margin: "16px 0px",
			height: 48,
		},
	},
}));

export const NavigationButtons = (props: NavigationButtonsProps) => {
	const {
		nextDisabled,
		prevBtnHidden,
		handleNavigatePrev,
		handleNavigateNext,
		isLastStep,
	} = props;

	const isMobile = useCommonWidths().isSmDown;
	const classes = useStyles();

	const logOutButton = useMemo(() => {
		return (
			<Grid container item>
				<MyPageButton
					buttonVariant="contained"
					actionType="cancel"
					backIcon
					className={classes.navigationButton}
					onClick={() => navigate("/logout")}
				>
					<FormattedMessage
						id="minside.onboarding.logOut-button"
						defaultMessage="Logg ut"
						description="Onboarding - Log out"
					/>
				</MyPageButton>
			</Grid>
		);
	}, [classes.navigationButton]);

	return (
		<>
			<Grid container item xs={isMobile ? 12 : 8} justify="space-between">
				<Grid item>
					{prevBtnHidden ? (
						logOutButton
					) : (
						<MyPageButton
							buttonVariant="contained"
							actionType="navigate"
							backIcon="chevron"
							className={classes.navigationButton}
							onClick={
								!prevBtnHidden && handleNavigatePrev
									? () => handleNavigatePrev()
									: undefined
							}
						>
							<FormattedMessage
								id="minside.onboarding.navigateBack-button"
								defaultMessage="Tilbake"
								description="Onboarding - Navigate to previous page"
							/>
						</MyPageButton>
					)}
				</Grid>
				<Grid item>
					<MyPageButton
						buttonVariant="contained"
						actionType="navigate"
						disabled={nextDisabled}
						nextIcon
						className={classes.navigationButton}
						onClick={() => handleNavigateNext()}
					>
						<FormattedMessage
							id="minside.onboarding.navigateBack-button"
							defaultMessage={
								isLastStep ? "Send inn skjema, og logg inn" : "Gå videre"
							}
							description="Onboarding - Navigate to next page"
						/>
					</MyPageButton>
				</Grid>
			</Grid>
			{!prevBtnHidden && logOutButton}
		</>
	);
};
